import {Component, OnInit} from '@angular/core';
import * as _ from 'lodash';

import 'rxjs/add/operator/map';
import {ActivatedRoute} from '@angular/router';
import {AuthRESTService} from '../../../services/rest/auth-rest.service';
import Rx from 'rxjs/Rx';
import Commons from '../../commons';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from 'ng2-translate';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
@Component({
    templateUrl: './user-edit.component.html',
    styleUrls: ['./user-edit.component.css']
})

export class UserPage extends Commons implements OnInit {
    roles: Array<any>;
    roleTypes: Array<any>;
    allInstitutions: Array<any> = [];
	user;
    initialUserRoles: any = [];
    selectedInstitutionId: number;
    selectedInstitutionUnitId: number;
	selectedRole: number;
	institutionsWithRoles: any = [];
	institutionUnitsWithRoles: any = [];

    institution;
    selectedInstitutionInstitutionUnits = [];

    selectedInstitutionIdForInstitutionOnly: number;
    selectedInstitutionUnitIdForInstitutionOnly: number;
	selectedRoleForInstitutionOnly: number;
	userPropsMap: Object = { // name is mapped separately as it is not regular prop
		primary_email: { label: "users.email" },
		first_name: { label: "users.firstname" },
		name: { label: "users.lastname" }
	};

    constructor(private route: ActivatedRoute, private rest: AuthRESTService, toastr: ToastrService, translate: TranslateService) {
		super(toastr, translate)
	}

    ngOnInit(): void {
        this.rest.get('roles').subscribe(response => {
            this.roles = response
        }, err => this.errorHandler(err));

        this.rest.get('institution/allFull').subscribe(response => {
			if (response) {
				this.allInstitutions = response;	
			}
            this.selectedInstitutionId = (this.allInstitutions[0] && this.allInstitutions[0].id) || null;
            this.selectedInstitutionIdForInstitutionOnly = this.selectedInstitutionId;

            this.rest.get('roles/types').subscribe(response => {
				this.roleTypes = response;
				this.initializeUserData();
                this.updateSelectedInstitutionInstitutionUnits()
            }, err => this.errorHandler(err))
        }, err => {
			this.allInstitutions = [];
			this.errorHandler(err);
		})
    }

    initializeUserData() {
		this.institutionsWithRoles = [];
		this.institutionUnitsWithRoles = [];
        this.route.params.subscribe((params) => {
			Observable.forkJoin([
				this.rest.get(`manager/user/${params['id']}`)
			]).subscribe((response) => {
				this.user = response[0];
				this.initialUserRoles = this.user.roles.slice(0);
				let userProps = [];
				Object.keys(this.userPropsMap).forEach((propMapKey) => {
					this.user.properties.some((prop) => {
						if (prop.name === propMapKey) {
							let value = Array.isArray(prop.values) ? prop.values[0].value : prop.value;
							userProps.push(Object.assign({ value: value }, this.userPropsMap[propMapKey]));
							return true;
						}
					});
				});
				this.user.properties = userProps;
				this.allInstitutions.forEach(inst => {
					this.roleTypes.forEach(role => {
						const institutionWithRole = {
							institution: Object.assign({}, inst),
							role: Object.assign({}, role),
							unitsWithRole: [],
							isActive: false,
							isInitialUserRole: false
						};
						this.user.institutionsRoles.some((instRole) => {
							if (instRole.institution.id === inst.id && role.id === instRole.businessRole.id) {
								institutionWithRole.isInitialUserRole = institutionWithRole.isActive = true;
								return true;
							}
						})

						if (inst.units) {
							inst.units.forEach((unit) => {
								const unitWithRole = Object.assign({}, unit, {
									role: role,
									isActive: false,
									institution: Object.assign({}, inst),
									isInitialUserRole: false
								});

								this.user.institutionsUnitRoles.some((instUnitRole) => {
									if (instUnitRole.institutionUnit.id === unit.id && role.id === instUnitRole.businessRole.id) {
										unitWithRole.isInitialUserRole = unitWithRole.isActive = true;
										return true;
									}
								})

								this.institutionUnitsWithRoles.push(unitWithRole);
							});
						}

						this.institutionsWithRoles.push(institutionWithRole);
					})
				});
                
            },err => this.errorHandler(err))
        });
	}
	
	removeRoleFromInstitution(institution, role) {
		this.institutionsWithRoles.some((instWithRole) => {
			if (instWithRole.institution.id === institution.id && instWithRole.role.id === role.id) {
				instWithRole.isActive = false;
				return true;
			}
		});
	}

	removeRoleFromInstitutionUnit(unit, role) {
		this.institutionUnitsWithRoles.some((unitWithRole) => {
			if (unitWithRole.id === unit.id && unitWithRole.role.id === role.id) {
				unitWithRole.isActive = false;
				return true;
			}
		});
	}

    institutionShouldBeShownInList(institutionId) {
		if (this.institutionsWithRoles.some((instWithRole) => {
			return instWithRole.institution.id === institutionId && instWithRole.isActive;
		})) {
			return true;
		}

		if (this.institutionUnitsWithRoles.filter(
			(unitWithRole) => { return unitWithRole.institution.id === institutionId; }
		).some((unitWithRole) => {
			return this.institutionUnitShouldBeShownInTheList(unitWithRole.id);
		})) {
			return true
		}

		return false;
    }

    institutionUnitShouldBeShownInTheList(institutionUnitId) {
        return this.institutionUnitsWithRoles.some((unitWithRole) => {
			return unitWithRole.id === institutionUnitId && unitWithRole.isActive;
		});
    }

    showInstitutionLabel(institutionId, roleTypeId) {
        return this.institutionsWithRoles.some((instWithRole) => {
			return instWithRole.institution.id === institutionId && instWithRole.role.id === roleTypeId && instWithRole.isActive;
		});
    }

    showInstitutionUnitLabel(institutionUnitId, roleTypeId) {
        return this.institutionUnitsWithRoles.some((unitWithRole) => {
			return unitWithRole.id === institutionUnitId && unitWithRole.role.id === roleTypeId && unitWithRole.isActive;
		});
    }

    addInstitutionOrInstitutionUnit() {
        if (this.selectedInstitutionUnitId) {
            if (this.showInstitutionUnitLabel(this.selectedInstitutionUnitId, this.selectedRole)) return;
            this.institutionUnitsWithRoles.some((unitWithRole) => {
				if (unitWithRole.id === this.selectedInstitutionUnitId && this.selectedRole === unitWithRole.role.id) {
					unitWithRole.isActive = true;
					return true;
				}
			})
        } else {
            if (this.showInstitutionLabel(this.selectedInstitutionId, this.selectedRole)) return;
			this.institutionsWithRoles.some((instWithRole) => {
				if (instWithRole.institution.id === this.selectedInstitutionId && instWithRole.role.id === this.selectedRole) {
					instWithRole.isActive = true;
					return true;
				}
			})
        }
    }

    addInstitutionOrInstitutionUnitForInstitutionOnly() {
        if (this.showInstitutionLabel(this.selectedInstitutionIdForInstitutionOnly, this.selectedRoleForInstitutionOnly)) return;
        this.institutionsWithRoles.some((instWithRole) => {
			if (instWithRole.institution.id === this.selectedInstitutionIdForInstitutionOnly && instWithRole.role.id === this.selectedRoleForInstitutionOnly) {
				instWithRole.isActive = true;
				return true;
			}
		})
    }

    updateSelectedInstitutionInstitutionUnits() {
        const selectedInstitution = this.getSelectedInstitutionId();
        if (selectedInstitution && selectedInstitution.units.length > 0) {
            this.selectedInstitutionInstitutionUnits = selectedInstitution.units;
            this.selectedInstitutionUnitId = selectedInstitution.units[0].id;
        } else {
            this.selectedInstitutionInstitutionUnits = [];
            this.selectedInstitutionUnitId = undefined;
        }
        this.updateSelectedRoles()
    }

    private getSelectedInstitutionId() {
        return this.allInstitutions.find(it => it.id === this.selectedInstitutionId);
    }

    updateSelectedRoles() {
		if (!this.roleTypes || !this.roleTypes.length) return;
        this.selectedRole = this.roleTypes[0].id;
        this.selectedRoleForInstitutionOnly = this.roleTypes[0].id;
    }

    save(): void {
		let roles = this.user.roles;
        let promises = [];

        let rolesToAdd = _.difference(roles, this.initialUserRoles);
        rolesToAdd.forEach((role) => {
            promises.push(this.rest.put(`role/add/${role}/${this.user.id}`, {}));
        });

        let rolesToRemove = _.difference(this.initialUserRoles, roles);
        rolesToRemove.forEach((role) => {
            promises.push(this.rest.delete(`role/remove/${role}/${this.user.id}`))
        });

        this.institutionUnitsWithRoles.filter(instUnitRole => { return instUnitRole.isActive && !instUnitRole.isInitialUserRole }).forEach((instUnitRole) => {
            promises.push(this.rest.put(`user/${this.user.id}/institutionUnit/${instUnitRole.id}/${instUnitRole.role.id}`, {}))
        });

        this.institutionUnitsWithRoles.filter(instUnitRole => { return !instUnitRole.isActive && instUnitRole.isInitialUserRole }).forEach((instUnitRole) => {
            promises.push(this.rest.delete(`user/${this.user.id}/institutionUnit/${instUnitRole.id}/${instUnitRole.role.id}`))
        });

        this.institutionsWithRoles.filter(instWithRole => { return instWithRole.isActive && !instWithRole.isInitialUserRole }).forEach((instWithRole) => {
            promises.push(this.rest.put(`user/${this.user.id}/institution/${instWithRole.institution.id}/${instWithRole.role.id}`, {}))
        });

        this.institutionsWithRoles.filter(instWithRole => { return !instWithRole.isActive && instWithRole.isInitialUserRole }).forEach((instWithRole) => {
            promises.push(this.rest.delete(`user/${this.user.id}/institution/${instWithRole.institution.id}/${instWithRole.role.id}`))
        });

        Observable.forkJoin(promises).subscribe(t => {
			this.initializeUserData();
            this.clearNotifications().addSuccess('general.saved');
        }, err =>{
            this.errorHandler(err)
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/user/user-edit/user-edit.component.ts